import React, { useState } from "react";
import axios from "axios";

const ForgetPasscode = () => {
  const [step, setStep] = useState(1);
  const [aadhar, setAadhar] = useState("");
  const [otp, setOtp] = useState("");
  const [newPass, setNewPass] = useState("");
  const [loading, setLoading] = useState(false);

  // 1️⃣ Send OTP
  const handleSendOtp = async () => {
    if (!aadhar || aadhar.length !== 12) {
      alert("Enter valid 12-digit Aadhar");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("https://yourapi.com/send-otp", { aadhar });
      if (res.data.success) {
        setStep(2);
      } else {
        alert(res.data.message || "Failed to send OTP");
      }
    } catch (err) {  
      alert("Error sending OTP");
    }
    setLoading(false);
  };

  // 2️⃣ Verify OTP
  const handleVerifyOtp = async () => {
    if (!otp) {
      alert("Enter OTP");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("https://yourapi.com/verify-otp", { aadhar, otp });
      if (res.data.success) {
        setStep(3);
      } else {
        alert(res.data.message || "OTP verification failed");
      }
    } catch (err) {
      alert("Error verifying OTP");
    }
    setLoading(false);
  };

  // 3️⃣ Reset Passcode
  const handleResetPass = async () => {
    if (!newPass || newPass.length < 4) {
      alert("Passcode must be at least 4 digits");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post("https://yourapi.com/reset-passcode", {
        aadhar,
        passcode: newPass,
      });
      if (res.data.success) {
        alert("Passcode reset successful!");
        window.location.href = "/login";
      } else {
        alert(res.data.message || "Passcode reset failed");
      }
    } catch (err) {
      alert("Error resetting passcode");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/gallery/matri.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "35px",
          borderRadius: "12px",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
          backdropFilter: "blur(3px)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "25px",
            color: "#2c3e50",
            fontSize: "1.8rem",
          }}
        >
          Forgot Passcode
        </h2>

        {step === 1 && (
          <>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Aadhar Number
            </label>
           <input
  type="text"
  placeholder="Enter 12-digit Aadhar"
  value={aadhar}
  onChange={(e) => {
    const value = e.target.value;
    // Allow only numbers and max 12 digits
    if (/^\d{0,12}$/.test(value)) {
      setAadhar(value);
    }
  }}
  maxLength={12}
  pattern="\d{12}"
  style={{
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    marginBottom: "15px",
  }}
  required
/>

            <button
              onClick={handleSendOtp}
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#3498db",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "17px",
                cursor: "pointer",
              }}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Enter OTP
            </label>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                marginBottom: "15px",
              }}
            />
            <button
              onClick={handleVerifyOtp}
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#3498db",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "17px",
                cursor: "pointer",
              }}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>
          </>
        )}

        {step === 3 && (
          <>
            <label style={{ display: "block", marginBottom: "6px" }}>
              New Passcode
            </label>
            <input
              type="password"
              placeholder="Enter New Passcode"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                marginBottom: "15px",
              }}
            />
            <button
              onClick={handleResetPass}
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#3498db",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "17px",
                cursor: "pointer",
              }}
            >
              {loading ? "Resetting..." : "Reset Passcode"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgetPasscode;
